<template>
  <label :for="card.payerid">
    Use Stored Card:
    <span class="card-pan">
      Card No: {{ card.pan }}
    </span>
    <span class="card-exp">
      Exp: ({{ card.expdate | cardExpFormat }})
    </span>
  </label>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'stored-cc',
  filters: {
    cardExpFormat(val) {
      return dayjs(val).format('MM/YY')
    }
  },
  props: {
    card: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
</style>
